import APIClient from '@/shared/http/clients/api'

const resourceName = 'saldo-medio-cco'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=id,desc`, config)

/**
 * @name AverageBalanceCCORepository
 * @description Saldo Médio Diocco
 * @type { Respository }
 */
const AverageBalanceCCORepository = {
  Search
}

export default AverageBalanceCCORepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/averagebalancecco.js